import React, { useEffect, useState, createContext, useContext } from 'react';
type ThemeType = 'light' | 'dark';
interface Colors {
  background: string;
  cardSurface: string;
  textPrimary: string;
  textSecondary: string;
  accent: string;
  divider: string;
  warning: string;
  error: string;
  success: string;
}
interface ThemeContextType {
  theme: ThemeType;
  setTheme: (theme: ThemeType) => void;
  colors: Colors;
}
const lightColors: Colors = {
  background: '#f5f7fa',
  cardSurface: '#ffffff',
  textPrimary: '#1a2236',
  textSecondary: '#4a5568',
  accent: '#2563eb',
  divider: '#e2e8f0',
  warning: '#f59e0b',
  error: '#ef4444',
  success: '#10b981'
};
const darkColors: Colors = {
  background: '#121827',
  cardSurface: '#1e293b',
  textPrimary: '#f1f5f9',
  textSecondary: '#94a3b8',
  accent: '#3b82f6',
  divider: '#334155',
  warning: '#f59e0b',
  error: '#ef4444',
  success: '#10b981'
};
const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
export function ThemeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [theme, setTheme] = useState<ThemeType>('light');
  const colors = theme === 'light' ? lightColors : darkColors;
  useEffect(() => {
    // Check for stored theme preference
    const storedTheme = localStorage.getItem('theme') as ThemeType | null;
    if (storedTheme) {
      setTheme(storedTheme);
    } else if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      setTheme('dark');
    }
  }, []);
  useEffect(() => {
    // Save theme preference
    localStorage.setItem('theme', theme);
  }, [theme]);
  return <ThemeContext.Provider value={{
    theme,
    setTheme,
    colors
  }} data-id="element-69">
      {children}
    </ThemeContext.Provider>;
}
export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) throw new Error('useTheme must be used within ThemeProvider');
  return context;
}